import { useEffect } from 'react';

export const useRefocusOnAddressInput = (
  isRefocusingAddressInput: boolean,
  setIsRefocusingAddressInput: (v: boolean) => void,
  addressInputElementRef: React.RefObject<HTMLInputElement | undefined>,
) => {
  useEffect(() => {
    if (isRefocusingAddressInput) {
      addressInputElementRef?.current?.focus();
      setIsRefocusingAddressInput(false);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [isRefocusingAddressInput]);
};

export const useRefocusOnUnitInput = (
  unitNumberDetected: boolean,
  isSubmitDisabled: boolean,
  unitNumberInputElementRef: React.RefObject<HTMLInputElement | undefined>,
) => {
  useEffect(() => {
    if (!isSubmitDisabled && unitNumberDetected && unitNumberInputElementRef.current) {
      unitNumberInputElementRef.current.focus();
      unitNumberInputElementRef.current.scrollIntoView(false);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [isSubmitDisabled]);
};
